

const Roles = {
    ADMIN: "admin",
    ORG_ADMIN: "org-admin",
    DEVICE_ADMIN: "device-admin",
}

export default Roles;